import {createContext, useContext} from 'react';
import type {AiChatMessageContextValue} from './ai-chat-message.types';

export const aiChatMessageContext = createContext<AiChatMessageContextValue | undefined>(undefined);

export function useAiChatMessage(): AiChatMessageContextValue {
  const value = useContext(aiChatMessageContext);

  if (value === undefined) {
    throw new Error('useAiChatMessage must be used within an aiChatMessageContext provider');
  }

  return value;
}
